<template>

  <!-- @vue-ignore: type for VDateInput update:modelValue event is incorrect in Vuetify 3.8.1 -->
  <v-date-input @update:modelValue="updated"
    v-bind="$attrs"
    :model-value="selectedDates"
    multiple="range"
    hide-actions
    prepend-icon=""
  />

</template>

<script setup lang="ts">

import { computed } from 'vue'
import { VDateInput } from 'vuetify/labs/VDateInput'
import { useDate } from 'vuetify'
import type { DateRange } from '../../types/misc'
import type { DateInstance } from 'vuetify'
import { Temporal } from '@js-temporal/polyfill'

const dateRange = defineModel<null | DateRange>({required: true})

const dateTools = useDate()

/**
 * Convert our custom DateRange model to the format expected by VDateInput.
 */
const selectedDates = computed<DateInstance[]>((): DateInstance[] => {

  if (!dateRange.value) return []

  // protect against infinite loop
  if (Temporal.PlainDate.compare(dateRange.value.end, dateRange.value.start) === -1) {
    throw new Error('dateRange end can\'t be before start')
  }

  const numDays = dateRange.value.start.until(dateRange.value.end, {largestUnit: 'day'}).total('day') + 1
  const output: DateInstance[] = []

  for (let i = 0; i < numDays; i++) {
    const di = dateTools.parseISO(dateRange.value.start.add({days: i}).toString()) as DateInstance
    output.push(di)
  }

  return output

})

function updated(newSelectedDates: DateInstance[]): void {

  if (!newSelectedDates) {
    dateRange.value = null
  }

  const foo = newSelectedDates.sort((a: DateInstance, b: DateInstance) => {

    if (dateTools.isEqual(a, b)) {
      return 0
    }

    return dateTools.isBefore(a, b) ? -1 : 1

  })

  // these are DateInstances, so we'll need to convert them to PlainDates
  const startDi = foo.at(0)
  const endDi = foo.at(-1)

  dateRange.value = {
    start: new Temporal.PlainDate(dateTools.getYear(startDi), dateTools.getMonth(startDi) + 1, dateTools.getDate(startDi)),
    end: new Temporal.PlainDate(dateTools.getYear(endDi), dateTools.getMonth(endDi) + 1, dateTools.getDate(endDi)),
  }

}

</script>
